import styled from "styled-components"
import Icons from "../Icons/index"

export const EmailWrapper = styled(Icons.Email)`
  color: #fff;
  width: 35px;
`
export const OldPhoneWrapper = styled(Icons.OldPhone)`
  color: #fff;
  width: 35px;
`

export const WhatsappWrapper = styled(Icons.Whatsapp)`
  color: #fff;
  width: 35px;
  @media screen and (max-width: 1025px) {
    width: 30px;
  }
`
export const MotorcycleWrapper = styled(Icons.Motorcycle)`
  color: blue;
  width: 35px;
`
export const CreditCardWrapper = styled(Icons.CreditCard)`
  color: green;
  width: 35px;
`
export const ShutterSpeedWrapper = styled(Icons.ShutterSpeed)`
  color: blue;
  width: 35px;
`
export const HeartsWrapper = styled(Icons.Hearts)`
  color: red;
  width: 35px;
`
export const AwardWrapper = styled(Icons.Award)`
  color: gold;
  width: 35px;
`
export const LocationOnWrapper = styled(Icons.LocationOn)`
  color: red;
  width: 35px;
  @media screen and (max-width: 1025px) {
    width: 30px;
  }
`
export const HomeWrapper = styled(Icons.Home)`
  color: #fff;
  width: 35px;
  @media screen and (max-width: 1025px) {
    width: 30px;
  }
`
export const LibraryBooksWrapper = styled(Icons.LibraryBooks)`
  color: #fff;
  width: 35px;
  @media screen and (max-width: 1025px) {
    width: 30px;
  }
`

export const HomeRepairServiceWrapper = styled(Icons.HomeRepairService)`
  color: #fff;
  width: 35px;
  @media screen and (max-width: 1025px) {
    width: 30px;
  }
`
